// /src/pdf/builders/retention/buildDoc.js
export function buildRetentionDoc({
  t, shortcode, stationName,
  date1,
  returned, newTotal, percent,
  period, fmtNumber, locale,
  logoDataUrl,
  serviceName
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('retention.title')) || '';

  // Логотип слева (если доступен)
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Шапка: название радио + дата отчетности
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        `${t('retention.end_date')}: ${date1}`
      ],
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // Основной показатель
  content.push({
    text: t('retention.returned_stat', {
      returned: fmtNumber(returned ?? 0, locale),
      total: fmtNumber(newTotal ?? 0, locale),
      percent: fmtNumber(percent ?? 0, locale)
    }),
    margin: [0, 0, 0, 6],
    fontSize: 12,
    bold: true
  });

  // Период (если есть)
  if (period) {
    content.push({
      text: period,
      color: '#666',
      fontSize: 10,
      margin: [0, 0, 0, 8]
    });
  }

  // Сводная таблица
  const body = [
    [
      { text: t('retention.title'), style: 'th', colSpan: 2, alignment: 'left' },
      {}
    ],
    [{ text: t('retention.returned_stat').split(':')[0] || 'Returned / Total / %', alignment: 'left' },
     { text: `${fmtNumber(returned ?? 0, locale)} / ${fmtNumber(newTotal ?? 0, locale)} / ${fmtNumber(percent ?? 0, locale)}%`, alignment: 'right' }]
  ];

  content.push({
    table: {
      headerRows: 1,
      widths: ['*', 'auto'],
      body
    },
    layout: {
      fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
      hLineColor: '#e0e0e0',
      vLineColor: '#e0e0e0',
    },
  });

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true },
    },
  };
}

export { buildRetentionDoc as default };
